import HP from "../host";
import { ApiService } from "./API";
const api = new ApiService(`${HP.request}://${HP.host}/api/v1`);
const RatingService = {
  getRatings: async (type: string, model: string, studentId?: string) => {
    if (studentId) {
      return await api.get(
        `/ratings?type=${type}&modal=${model}&createdBy=${studentId}`
      );
    }
    return await api.get(`/ratings?type=${type}&modal=${model}`);
  },
};
export default RatingService;
